import React from 'react'

function LockIcon({ width, height, className }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 16 21">
            <path id="Vector_-_2025-02-17T231408.219" data-name="Vector - 2025-02-17T231408.219" d="M2,21a1.925,1.925,0,0,1-1.412-.587A1.93,1.93,0,0,1,0,19V9A1.923,1.923,0,0,1,.588,7.588,1.931,1.931,0,0,1,2,7H3V5A4.816,4.816,0,0,1,4.463,1.463,4.824,4.824,0,0,1,8,0a4.817,4.817,0,0,1,3.538,1.463A4.812,4.812,0,0,1,13,5V7h1a2.006,2.006,0,0,1,2,2V19a2,2,0,0,1-2,2Zm6-5a2,2,0,0,0,0-4,1.909,1.909,0,0,0-1.412.588A1.945,1.945,0,0,0,6,14a2.006,2.006,0,0,0,2,2ZM5,7h6V5a2.893,2.893,0,0,0-.875-2.125A2.893,2.893,0,0,0,8,2a2.893,2.893,0,0,0-2.125.875A2.893,2.893,0,0,0,5,5Z" />
        </svg>
    )
}

export default LockIcon